(function (app, ng) {
    app.component("configureApplicationWorkflow",
        {
            controller: configureApplicationWorkflowController,
            templateUrl: "/App/Dashboard/ConfigureTransactionGroup/Workflows/Application/template.html",
            bindings: {
                transactionGroup: "<",
                onSave: "&",
                publishedTransactionGroup: "<"
            }
        });

    configureApplicationWorkflowController.$inject = ["_", "figToaster", "figToastContainers", "queueApi", "transactionGroupApi", "permissionService"];
    function configureApplicationWorkflowController(_, figToaster, figToastContainers, queueApi, transactionGroupApi, permissionService) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                UI: {
                    selectedQueue: null
                },
                queueWorkflow: null,
                queues: null,                     
                addNotificationEmail: addNotificationEmail,
                removeNotificationEmail: removeNotificationEmail,
                permissionService: permissionService,
                updateUnpublishedChanges: updateUnpublishedChanges,
                checkUnpublishedChanges: checkUnpublishedChanges
            });

        this.$onInit = function () {

            $ctrl.onSave({
                $func: function () {
                    console.log("save")
                    return transactionGroupApi.updatePaperAppEmails($ctrl.notificationEmails);
                }
            });
            checkUnpublishedChanges();
            //console.log($ctrl.transactionGroup)

            if ($ctrl.transactionGroup.SubmittedPaperApplicationEmails === null) {
                $ctrl.transactionGroup.SubmittedPaperApplicationEmails = [];
            }


            //transactionGroupApi.getQueueWorkflow($ctrl.transactionGroup.QueueWorkflowId).then(function (response) {
            //    $ctrl.queueWorkflow = response;
            //    $ctrl.notificationEmails = [];

            //    queueApi.getQueues().then(function(queues) {
            //        $ctrl.queues = _.differenceBy(queues, $ctrl.queueWorkflow.Queues, "QueueId");
            //    });

            //});
        };

        function addNotificationEmail(e) {           
            if (e.keyCode === 13) {
                $ctrl.transactionGroup.UnpublishedChanges++;
                $ctrl.transactionGroup.SubmittedPaperApplicationEmails.push($ctrl.newEmail);
                console.log($ctrl.transactionGroup.SubmittedPaperApplicationEmails)
                transactionGroupApi.updatePaperAppEmails($ctrl.transactionGroup);    
                $ctrl.newEmail = "";
            }
        }

        function removeNotificationEmail(emailToRemove) {
            $ctrl.transactionGroup.UnpublishedChanges++;
            var index = _.findIndex($ctrl.transactionGroup.SubmittedPaperApplicationEmails,
                function (email) {
                    return email === emailToRemove;
                });
            $ctrl.transactionGroup.SubmittedPaperApplicationEmails.splice(index, 1);          
            transactionGroupApi.updatePaperAppEmails($ctrl.transactionGroup);          
        }

        function updateUnpublishedChanges(item) {
            if (item.Unpublished === true)
                $ctrl.transactionGroup.UnpublishedChanges++;
            else
                $ctrl.transactionGroup.UnpublishedChanges--;
        }

        function checkUnpublishedChanges() {
            if ($ctrl.publishedTransactionGroup && $ctrl.transactionGroup) {

                ng.forEach($ctrl.transactionGroup.DeterminePoints, function (point) {
                    if (!_.find($ctrl.publishedTransactionGroup.DeterminePoints, function (p) {
                        return p === point;
                    })) {
                        _.find($ctrl.determinePoints, function (p) {
                            return p.Value === point;
                        }).Unpublished = true;
                    }
                });

                ng.forEach($ctrl.publishedTransactionGroup.DeterminePoints, function (point) {
                    if (!_.find($ctrl.transactionGroup.DeterminePoints, function (p) {
                        return p === point;
                    })) {
                        _.find($ctrl.determinePoints, function (p) {
                            return p.Value === point;
                        }).Unpublished = true;
                    }
                });

                ng.forEach($ctrl.transactionGroup.RequiredDetermineDocuments, function (doc) {
                    if (!_.find($ctrl.publishedTransactionGroup.RequiredDetermineDocuments, function (d) {
                        return d.Value === doc.Value && _.isEqual(d.FundingSources.sort(), doc.FundingSources.sort());
                    })) {
                        _.find($ctrl.requiredDetermineDocuments, function (d) {
                            return d.Value === doc.Value && _.isEqual(d.FundingSources.sort(), doc.FundingSources.sort());
                        }).Unpublished = true;
                    }
                });

                ng.forEach($ctrl.publishedTransactionGroup.RequiredDetermineDocuments, function (doc) {
                    if (!_.find($ctrl.transactionGroup.RequiredDetermineDocuments, function (d) {
                        return d.Value === doc.Value && _.isEqual(d.FundingSources.sort(), doc.FundingSources.sort());
                    })) {
                        _.find($ctrl.requiredDetermineDocuments, function (d) {
                            return d.Value === doc.Value && _.isEqual(d.FundingSources.sort(), doc.FundingSources.sort());
                        }).Unpublished = true;
                    }
                });
            } else {
                ng.forEach($ctrl.determinePoints, function (point) {
                    if (point.IsActive)
                        point.Unpublished = true;
                });

                ng.forEach($ctrl.transactionGroup.RequiredDetermineDocuments, function (doc) {
                    doc.Unpublished = true;
                });
            }
        }
    };
})(window.app, window.angular); //jshint ignore:line